import React from "react";
import gsap from "gsap";
import First from "./Sections/First";
import Second from "./Sections/Second";
import Third from "./Sections/Third";
import Fourth from "./Sections/Fourth";
import Header from "./Components/Header";
import Tagline from "./Components/Tagline";
import Footer from "./Components/Footer";

class Scroller extends React.Component {
  componentDidMount() {
    const sections = document.querySelectorAll("section");
    const images = document.querySelectorAll(".bg");
    const outerWrappers = gsap.utils.toArray(".outer");
    const innerWrappers = gsap.utils.toArray(".inner");

    document.addEventListener("wheel", handleWheel);
    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);

    let scrollicon = document.getElementById("scrolldown");

    let listening = false,
      direction = "down",
      current,
      next = 0;

    const touch = {
      startX: 0,
      startY: 0,
      dx: 0,
      dy: 0,
      startTime: 0,
      dt: 0,
    };

    const tlDefaults = {
      ease: "slow.inOut",
      duration: 1.25,
    };

    gsap.set(outerWrappers, { yPercent: 100 });
    gsap.set(innerWrappers, { yPercent: -100 });

    // Slides a section in on scroll down
    function slideIn() {
      // The first time this function runs, current is undefined
      if (current !== undefined) gsap.set(sections[current], { zIndex: 0 });

      gsap.set(sections[next], { autoAlpha: 1, zIndex: 1 });
      gsap.set(images[next], { yPercent: 0 });
      let overrideList = true;
      if (current === 0) {
        overrideList = false;
      }
      const tl = gsap
        .timeline({
          paused: true,
          defaults: tlDefaults,
          onComplete: () => {
            listening = overrideList;
            current = next;
          },
        })
        .to([outerWrappers[next], innerWrappers[next]], { yPercent: 0 }, 0)
        .from(images[next], { yPercent: 15 }, 0);

      if (current !== undefined) {
        if (current === 0) {
          let tlslide = gsap.timeline({
            onComplete: () => {
              listening = true;
            },
          });
          tlslide.to(document.getElementById("tagline"), {
            opacity: 0,
            duration: 0.7,
            ease: "Power2.easeInOut",
          });
          tlslide.to(
            document.getElementById("tagline"),
            {
              scale: 2,
              duration: 1,
              ease: "Power2.easeInOut",
            },
            "<"
          );
          tlslide.to(
            document.getElementById("secondreveal"),
            {
              opacity: 0,
              duration: 3,
              ease: "Power2.easeInOut",
              onComplete: () => {
                document.getElementById("secondreveal").style.display = "none";
                document.getElementById("tagline").style.display = "none";
                document
                  .getElementById("secondtext-l")
                  .classList.add("text-focus-in-l");
                document
                  .getElementById("secondtext-r")
                  .classList.add("text-focus-in-r");
                document
                  .getElementById("secondtext-m")
                  .classList.add("text-focus-in-m");

                gsap.to(scrollicon, {
                  opacity: 1,
                  duration: 1,
                });
              },
            },
            "<"
          );
          tlslide.play();
        }
        tl.add(
          gsap.to(images[current], {
            yPercent: 0,
            ...tlDefaults,
          }),
          0
        ).add(
          gsap
            .timeline()
            .set(outerWrappers[current], { yPercent: 100 })
            .set(innerWrappers[current], { yPercent: -100 })
            .set(images[current], { yPercent: 0 })
            .set(sections[current], { autoAlpha: 0 })
        );
      }
      tl.play(0);
    }

    // Slides a section out on scroll up
    function slideOut() {
      gsap.set([outerWrappers[next], innerWrappers[next]], { yPercent: 0 });
      gsap.set(images[next], { yPercent: 0 });
      gsap.set(sections[next], { autoAlpha: 1, zIndex: 1 });

      gsap
        .timeline({
          defaults: tlDefaults,
          onComplete: () => {
            listening = true;
            sections[current].style.zIndex = 0;
            current = next;
          },
        })
        .to(outerWrappers[current], { yPercent: 100 }, 0)
        .to(innerWrappers[current], { yPercent: -100 }, 0)
        .to(images[current], { yPercent: 0 }, 0)
        .from(images[next], { yPercent: 0 }, 0)
        .set(images[current], { yPercent: 0 });

      if (next === 0) {
        document.getElementById("secondreveal").style.display = "block";
        document.getElementById("tagline").style.display = "block";
        gsap.to(document.getElementById("secondreveal"), {
          opacity: 1,
          duration: 0.5,
          onComplete: () => {
            gsap.to(document.getElementById("tagline"), {
              scale: 1,
              duration: 2,
              opacity: 1,
            });
          },
        });
      }
    }

    function secondsectionIn() {
      let i = document.querySelector(".brainContainer");
      i.classList.add("pushanimation");
      let j = document.querySelector(".brainsvg");
      j.classList.add("shrinkanimation");
      document.querySelectorAll(".color").forEach((element) => {
        element.classList.add("expanded");
      });
      gsap.set(outerWrappers[next], {
        yPercent: 0,
        width: 0,
        height: 0,
        borderRadius: "50%",
      });
      gsap.set(innerWrappers[next], { yPercent: 0 });
      gsap.set(sections[next], {
        zIndex: 1,
        visibility: "visible",
      });
      gsap.set(images[next], { yPercent: 0 });

      let tlslide = gsap.timeline({
        onComplete: () => {
          listening = true;
          sections[current].style.zIndex = 0;
          i.classList.remove("pushanimation");
          j.classList.remove("shrinkanimation");
          document.querySelectorAll(".color").forEach((element) => {
            element.classList.remove("expanded");
          });
          current = next;
        },
      });
      tlslide.to(outerWrappers[next], {
        width: "54%",
        height: "100%",
        duration: 0.6,
        delay: 2.2,
      });
      tlslide.to(
        outerWrappers[next],
        {
          borderRadius: "0%",
          width: "100%",
          duration: 0.2,
        },
        ">"
      );

      tlslide.to(
        document.getElementById("heading-1"),
        { opacity: 1, duration: 0.4 },
        ">"
      );
      tlslide.to(
        document.getElementById("heading-2"),
        { opacity: 1, duration: 0.4 },
        "<"
      );
      tlslide.to(
        document.getElementById("heading-3"),
        { opacity: 1, duration: 0.4 },
        "<"
      );
      tlslide.to(
        document.getElementById("statement"),
        { opacity: 1, duration: 0.4 },
        ">"
      );
      tlslide.to(
        document.getElementById("button-1"),
        { opacity: 1, duration: 0.4 },
        ">"
      );
      tlslide.to(
        document.getElementById("button-2"),
        { opacity: 1, duration: 0.4, delay: 0.2 },
        ">"
      );
      tlslide.to(
        document.getElementById("button-3"),
        { opacity: 1, duration: 0.4, delay: 0.2 },
        ">"
      );
      tlslide.to(
        document.getElementById("DTid"),
        { opacity: 0.4, duration: 1 },
        ">"
      );
      tlslide.play();
    }

    function handleDirection() {
      listening = false;

      if (direction === "down") {
        scrollicon.style.opacity = 0;
        scrollicon.style.right = "20px";
        scrollicon.style.left = "auto";
        if (current !== sections.length - 1) {
          next = current + 1;
          if (current === 1) {
            secondsectionIn();
          } else {
            slideIn();
          }
        } else {
          listening = true;
        }
      }

      if (direction === "up") {
        if (current !== 0) {
          next = current - 1;
          slideOut();
        } else {
          listening = true;
        }
      }
    }

    function handleWheel(e) {
      if (!listening) return;
      direction = e.wheelDeltaY < 0 ? "down" : "up";
      handleDirection();
    }

    function handleTouchStart(e) {
      if (!listening) return;
      const t = e.changedTouches[0];
      touch.startX = t.pageX;
      touch.startY = t.pageY;
    }

    function handleTouchMove(e) {
      if (!listening) return;
      e.preventDefault();
    }

    function handleTouchEnd(e) {
      if (!listening) return;
      const t = e.changedTouches[0];
      touch.dx = t.pageX - touch.startX;
      touch.dy = t.pageY - touch.startY;
      if (touch.dy > 10) direction = "up";
      if (touch.dy < -10) direction = "down";
      if (Math.abs(touch.dy) > 50) {
        handleDirection();
      }
    }

    slideIn();
  }
  render() {
    return (
      <React.Fragment>
        <Header />
        <First />
        <Tagline />
        <Second />
        <Third />
        <Fourth />
        <Footer />
      </React.Fragment>
    );
  }
}
export default Scroller;
